module.exports = __webpack_public_path__ + "static/img/reporticon13.089b4cb6.png";